let initialState = {

};

export type LoginInitialStateType = typeof initialState

//Reducer
export const profileReducer = (state = initialState, action: any): LoginInitialStateType => {
    switch (action.type) {

        default:
            return state;
    }
};



// actions


//thunks

// Action Creators



// type ActionsTypes
